module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.href) ? _c('a', {
    staticClass: "button",
    class: _vm.iconArrow,
    attrs: {
      "href": _vm.isLink
    }
  }, [(_vm.hasIcon) ? [_c('span', {
    staticClass: "icon",
    class: _vm.iconClass
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._t("default")], 2)], 2) : _c('button', {
    staticClass: "button",
    class: _vm.iconArrow,
    attrs: {
      "type": _vm.type
    }
  }, [(_vm.hasIcon) ? [_c('span', {
    staticClass: "icon",
    class: _vm.iconClass
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5df75368!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RoundButton.vue
// module id = 139
// module chunks = 1